export const SYSTEM_DISK_NAME = 'rootfs';

export { DEFAULT_DISK_SIZE, DISK_SIZE_MARK_COUNT, DISK_SIZE_MAX_GI, DISK_SIZE_MIN_GI } from '../../components/diskVolumeFields/constants';
